import { lazy, Suspense } from 'react';
import clsx from 'clsx';
import styles from './DocumentViewer.module.scss';

const DocumentViewer = lazy(() => import('./DocumentViewer'));

interface DocumentViewerLazyProps {
  pdfPath: string;
  className?: string;
}

const DocumentViewerFallback = ({ className }: { className?: string }) => (
  <div className={clsx(styles.container, className)} data-pdf-ready="false" data-pdf-error="false">
    <div className={styles.viewerContainer} role="presentation">
      <div className={styles.documentViewer} />
    </div>
  </div>
);

const DocumentViewerLazy = ({ pdfPath, className }: DocumentViewerLazyProps) => (
  <Suspense fallback={<DocumentViewerFallback className={className} />}>
    <DocumentViewer pdfPath={pdfPath} className={className} />
  </Suspense>
);

export default DocumentViewerLazy;
